var audio_rtlignore_default = {
  "fontElementMap": "UNIDv",
  "container": "N7vme",
  "customPlayer": "xKhxG",
  "slim": "EUTCo",
  "playPauseButton": "zrdDP",
  "coverImage": "XfLz2",
  "trackDetailsContainer": "rKyY5",
  "controlsContainer": "SQpgc",
  "controlsGroup": "Qjvsl",
  "sliderContainer": "gQhiD",
  "audioDuration": "VkIOd",
  "isLoading": "eGJC9",
  "audioIconButton": "AoPFd",
  "audioVolumeWrapper": "Kxjfy",
  "volumeSliderWrapper": "srSao",
  "audioDetails": "ayrf1",
  "authorName": "oBo3J",
  "title": "_7xUh-",
  "audioContextMenuWrapper": "wxNxL",
  "dropdownMenuWrapper": "DhkzR",
  "dropdownSelectedButton": "_5sokc",
  "dropdownContent": "YWwDK",
  "dropdownContentWithIcon": "HDdoS",
  "audioLoader": "vc8M0"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
